<sbnb-thermostat-preset-adjustment
  [config]="{
    title: 'Occupied',
    description: 'Set your desired temperature range:',
    question: 'at check-in',
    icon: 'occupied',
    continueRoute: 'unoccupied',
    presetType: 'occupied'
  }">
  <p>
    The
    <strong>Occupied preset</strong>
    activates
    <strong>2 hours before check-in,</strong>
    bringing your property to the perfect temperature for guests arrival. It stays active through the reservation to
    maintain comfort.
  </p>

  <p>
    You can also allow guests to control the thermostat during their stay by enabling the Guest Control setting under
    <strong>Devices > Settings > Thermostats.</strong>
  </p>
</sbnb-thermostat-preset-adjustment>
